module.exports = __webpack_public_path__ + "img/img86.e80288d4.png";